export default __webpack_public_path__ + "static/media/logout_icon.00462d4b.svg";